/**
 * Processes and evaluates dynamic logical expressions.
 * @param {string|boolean} condition
 * @param {Object} context - Object with variables (e.g., { supplierNit: '123' }).
 * @param {Object} extraContext - Object with variables (e.g., { supplierNit: '123' }).
 * @returns {boolean}
 */

export const evaluateCondition = (condition, context = {}, extraContext = {}) => {
    const safeContext = { ...context, ...extraContext };

    if (condition === undefined || condition === null || condition === true || condition === "") return true;
    if (condition === false) return false;

    // Resuelve rutas tipo "configuration.ERP" dentro del contexto
    const getValueByPath = (obj, path) =>
        path.split('.').reduce((acc, key) => (acc == null ? undefined : acc[key]), obj);

    try {
        // const sanitizedCondition = condition.replace(/{([\w.]+)}/g, (match, path) => {
        //     const value = getValueByPath(safeContext, path);

        //     if (value === undefined) return 'undefined';
        //     if (typeof value === 'string') return `'${value.replace(/'/g, "\\'")}'`;
        //     if (typeof value === 'object') return JSON.stringify(value);
        //     return value;
        // });
        const sanitizedCondition = condition.replace(/{([\w.]+)}/g, (match, path) => {
            const value = getValueByPath(safeContext, path);

            if (value === undefined) return 'undefined';

            if (typeof value === 'string') {
                return JSON.stringify(value);
            }

            if (typeof value === 'object') {
                return JSON.stringify(value);
            }

            return value;
        });
        console.log('sanitizedCondition ', sanitizedCondition);
        const runner = new Function(`return (${sanitizedCondition})`);
        return !!runner();
    } catch (error) {
        console.warn("Error en validación dinámica:", { condition, error });
        return false;
    }
};


